import { Icon as Iconify, type IconProps as IconifyProps } from "@iconify/react";

/**
 * Iconify o'rovchisi. Figma §7: barcha ikonalar Iconify orqali, nomlar bilan.
 * Standart o'lcham 24px (nav/qatorlar), rang `currentColor` dan meros.
 *
 * Foydalanish:  <Icon name={ICONS.kabinet} />  yoki  <Icon name="solar:heart-bold" size={20} />
 */
interface IconProps extends Omit<IconifyProps, "icon"> {
  name: any;
  size?: number;
}

export function Icon({ name, size = 24, ...rest }: IconProps) {
  return <Iconify icon={name} width={size} height={size} {...rest} />;
}

/** Figma §7 da ko'rsatilgan aniq Iconify nomlari — bitta manba. */
export const ICONS = {
  // Pastki navigatsiya
  helpGiven: "solar:check-read-outline", // Yordam berildi tab + done belgisi
  news: "hugeicons:news", // Yangiliklar tab
  kabinet: "solar:user-linear", // Kabinet tab
  // Kabinet qatorlari
  createApp: "hugeicons:note-01", // Ariza berish
  myApps: "hugeicons:note-03", // Mening arizalarim
  language: "meteor-icons:language", // Tilni almashtirish
  theme: "ion:invert-mode", // Mavzu
  // Umumiy
  close: "material-symbols:close-rounded", // sheet / modal yopish
  chevron: "ep:arrow-down", // dropdown / chevron / expand
  success: "ep:success-filled", // muvaffaqiyat tasdiqlash
  required: "mdi:required", // majburiy maydon yulduzchasi
  plus: "ic:round-plus", // qo'shish (fayl, element)
  file: "solar:file-linear", // fayl / hujjat
  delete: "proicons:delete", // yuklangan faylni o'chirish
  warning: "si:warning-line", // inline validatsiya ogohlantirishi
  // Til bayroqlari
  flagUz: "circle-flags:lang-uz",
  flagRu: "circle-flags:lang-ru",
  flagEn: "circle-flags:lang-en",
  // Qo'shimcha umumiy (navigatsiya/holat)
  back: "ep:arrow-left",
  chevronRight: "ep:arrow-right",
  clock: "solar:clock-circle-linear",
  empty: "solar:clipboard-list-linear",
} as const;
